import { exec } from '../utils/exec';
import { getApiToken } from '../utils/tokenExchange';
import type {
  GetVariantSkuDetailsArgs,
  GetVariantSkuDetailsExecVariables,
  GetVariantSkuDetailsExecResponse,
  VariantDetails,
  CatalogDataFieldDefinitions,
} from '@src/types/catalog';

/**
 * Fetches detailed information for a specific variant SKU
 * @param args - Contains token, partnerCode, and sku
 * @returns Promise resolving to variant details
 */
interface VariantDetailsWithDefinitions extends VariantDetails {
  catalogDataFieldDefinitions?: CatalogDataFieldDefinitions | null;
}

export const getVariantSkuDetails = async (
  args: GetVariantSkuDetailsArgs
): Promise<VariantDetailsWithDefinitions> => {
  const { partnerCode, sku } = args;
  const token = await getApiToken(args.token);

  const query = `
    query variantSkuDetails(
      $sku: String!
      $partnerCode: String!
      $token: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          catalogDataFieldDefinitions
          variantSkuDetails(sku: $sku) {
            upc
            mpn
            gtin
            partnerSku
            partnerParentSku
            family
            data
            partnerImageUrls
          }
        }
      }
    }
  `;

  const variables: GetVariantSkuDetailsExecVariables = {
    token,
    partnerCode,
    sku,
  };

  const data = await exec<GetVariantSkuDetailsExecVariables, GetVariantSkuDetailsExecResponse>(
    query,
    { variables }
  );

  return {
    ...data.restUser.partner.variantSkuDetails,
    catalogDataFieldDefinitions: data.restUser.partner.catalogDataFieldDefinitions,
  };
};
